<template>

  <div id="relatorio">

    <div v-if="step === 1">
      <div class="botoes-upload">
      <input class="upload" type="file" @change="onFileChange" id="input" />
      <b-button :disabled="disabled"  class="imprimir" type="button" variant="primary"  @click="go">Avancar</b-button>
      </div>
    </div>

    <div v-if="step === 2">
      <div class="lista-container">
    <div class="new-page">
      <div class="botoes">
      <b-button class="voltar" type="button" variant="primary" @click="go">Voltar</b-button>
      <b-button class="imprimir" type="button" variant="primary" @click="imprimir()"
      >Imprimir ou PDF</b-button>
      </div>
      <div  class="titulo-page">
        <h1>{{ cidadeCP }} – {{ estadoCP }}</h1>
      </div>
      <div class="subtitulo-page">
        <h2>
          OPORTUNIDADE PARA MAIS RECURSOS DO PREVINE BRASIL
        </h2>
      </div>
      <div class="subtitulo-2">
        O presente relatório tem por objetivo analisar a oportunidade de o
        município maximizar o recebimento dos recursos da capitação ponderada,
        pagamento por desempenho, informatiza APS e outras ações estratégicas,
        para identificar quanto pode-se receber a mais no âmbito do Programa
        Previne Brasil.
      </div>
        <div class="c-secao">
          <br>
        <h3>Resumo</h3>
        <br>
      <p>O município de <strong>{{ cidadeCP }} – {{ estadoCP }}</strong> tem oportunidade de receber mais
        recursos federais para as ações e serviços
        de saúde na APS. O valor que está deixando de receber por não atender totalmente aos requisitos do Previne Brasil
        pode chegar a <strong>{{moneyBr(totalPrevineBrasil * 12)}} no ano.</strong> Por mês esse valor é cerca de <strong>{{moneyBr(totalPrevineBrasil)}}</strong>
        que é a soma de {{moneyBr(valorAReceberCapitacaoPonderada)}} (capitação ponderada) + {{moneyBr(segundoValorQuePodeReceberAMais)}}
        (pagamento por desempenho) + {{moneyBr(valorQuePodeReceberAMaisInformatizaAps)}} (informatiza APS). </p>
        <br>
          <div class="header-blue">1 Introdução</div>
          <div class="c-secao-item">
            <p class="c-indent">
              O Programa Previne Brasil definiu o novo modelo de financiamento
              federal da Atenção Primária a Saúde (APS) a partir de 3 (três)
              componentes: capitação ponderada, pagamento por desempenho e
              programas e ações estratégicas.
            </p>
            <p class="c-indent">
              Para ter acesso a esses recursos, o município precisa realizar
              adesões e atender a conjunto de requisitos estabelecidos.
              <i
                >A principal pergunta que se faz é: será que o município já
                recebe o máximo que o Previne Brasil pode pagar, ou ainda tem
                oportunidade de receber mais recursos federais na APS, ou seja,
                maximizar o recebimento dos recursos federais?</i
              >
            </p>
            <p   class="c-indent">
              O município de <strong>{{ cidadeCP }} – {{ estadoCP }}</strong>,
              classificado com tipologia <strong>{{dadosCapitacaoPonderada.tipologia}}</strong> pelo Instituto Brasileiro de Geografia
              e Estatística (IBGE), tem
              <strong>{{somaEquipesPagas}} equipes</strong> de saúde validas no quadrimestre
              <strong>{{ quadrimestreReferencia }}</strong
              >, as quais estão distribuídas de acordo com o Quadro 1. As
              modalidades de equipes são: Equipe de Saúde da Família (eSF) e
              Equipe de Atenção Primária à Saúde (eAP).
            </p>
            <div>
              <p class="mb-0">Quadro 1 – Equipes por modalidade</p>
              <table class="tabela quadro-1 sem-negrito-th">
                <thead>
                  <tr style="margin: 20px 0px">
                  <th>eSF</th>
                  <th>eAP 20 horas</th>
                  <th>eAP 30 horas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{dadosCapitacaoPonderada.calculoQuadrimestre.qtdEsfQuadrimestre}}</td>
                    <td>{{dadosCapitacaoPonderada.calculoQuadrimestre.qtdEap20Quadrimestre}}</td>
                    <td>{{dadosCapitacaoPonderada.calculoQuadrimestre.qtdEap30Quadrimestre}}</td>
                  </tr>
                </tbody>
              </table>
              <p>Fonte: E-GESTOR, {{parcelaDIsf}}</p>

               <p v-if="somaDasEquipesHomologadas > somaDasEquipesPagas " class="c-indent">O município tem <strong>{{somaDasEquipesHomologadas}} equipes</strong> de saúde homologadas, mas na competência de {{parcelaDIsf}}, recebeu somente por <strong>{{somaDasEquipesPagas}} equipes</strong>, ou seja,
                está deixando de receber recursos na capitação ponderada por <strong>{{somaDasEquipesHomologadas - somaDasEquipesPagas}} equipes</strong> de saúde que estão homologadas e não pagas.</p>

              <p class="c-indent">Este relatório foi processado com base nos dados de <strong>{{parcelaCP}}</strong>
                do <strong><a href="https://egestorab.saude.gov.br/paginas/acessoPublico/relatorios/relPagamentoIndex.xhtml" target="_blank">E-GESTOR AB</a></strong>, na data de <strong>{{dataHoje}}</strong>. Ao analisar os dados aqui apresentados,
                faz-se necessário que você esteja de posse do relatório mais atual possível, pois se este relatório foi
                processado há mais de 4 meses, então ele já se encontra desatualizado e não reflete mais a
                realidade municipal.</p>
            </div>
          </div>
        </div>
</div>
  <div class="new-page">
        <div class="c-secao">
          <div class="header-blue">2 CAPITAÇÃO PONDERADA</div>
          <div class="c-secao-item">
            <p class="c-indent">
              O cadastro populacional qualificado é a base para as demais ações
              e a assistência prestada à população na APS no âmbito do Programa
              Previne Brasil a nível municipal. O novo modelo de financiamento
              federal da APS foi instituído pela Portaria 2.979 de 12 de
              novembro de 2019.
            </p>
            <p class="c-indent">
              O Quadro 2 mostra que a estimativa populacional do município de
              <strong>{{ cidadeCP }} – {{ estadoCP }}</strong> segundo o IBGE,
              foi de  <strong>{{dadosCapitacaoPonderada.populacao}} pessoas</strong>. Já foram cadastradas em equipes válidas e
              enviados ao Sistema de Informação da Atenção Básica (SISAB) o
              total de  <strong>{{dadosCapitacaoPonderada.calculoQuadrimestre.cadastroEsfEap.toLocaleString()}} pessoas</strong>. Considerando a estimativa do IBGE
              (<strong>{{dadosCapitacaoPonderada.populacao}} pessoas</strong>), <span v-if="verificaSeFaltaCadastrarPositivoOuNegativo">ainda
              <strong>faltam serem cadastradas</strong>
              e enviadas para o SISAB <strong>{{faltaCadastrar.toLocaleString()}} pessoas</strong>.</span>
              <span v-if="verificaSeFaltaCadastrarPositivoOuNegativo === false">
              já foram cadastradas a mais <strong>{{faltaCadastrar.toLocaleString()}}</strong> pessoas e enviadas ao SISAB.</span>
            </p>
            <p v-if="verificacaoCadastroForMaiorQuePotencialDeCadastro"  class="c-indent">No entanto, o potencial de cadastros <strong>({{dadosCapitacaoPonderada.calculoQuadrimestre.cadastroPotencial.toLocaleString()}} pessoas)</strong>
             é menor do que a quantidade de cadastros realizados <strong>({{dadosCapitacaoPonderada.calculoQuadrimestre.cadastroEsfEap.toLocaleString() }} pessoas)</strong>.
             Isso significa que a quantidade de equipes de saúde que o municipio tem, não é sulficiente para acompanhar
             <strong>{{cadastroMenosPotencialDeCadastro.toLocaleString()}} pessoas</strong>. Faz-se necessário implantar mais equipes de saúde.
            </p>
            <div>

              <p class="mb-0">Quadro 2 - Situação do cadastro populacional</p>
              <table class="tabela">
                <thead>
                  <tr>
                  <th>População<br>IBGE</th>
                  <th>Cadastro<br>potencial</th>
                  <th>Cadastros<br>realizados</th>
                  <th v-if="verificaSeFaltaCadastrarPositivoOuNegativo">Falta <br>cadastrar</th>
                  <th v-if="verificaSeFaltaCadastrarPositivoOuNegativo === false">Cadastros a<br>mais</th>
                  <th>Vulneráveis</th>
                  <th>Não<br>Vulneráveis</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="height: 35px;">
                    <td>{{dadosCapitacaoPonderada.populacao.replace('.', '')}}</td>
                    <td>{{dadosCapitacaoPonderada.calculoQuadrimestre.cadastroPotencial}}</td>
                    <td>{{dadosCapitacaoPonderada.calculoQuadrimestre.cadastroEsfEap}}</td>
                    <td>{{faltaCadastrar}}</td>
                    <td>{{dadosCapitacaoPonderada.calculoQuadrimestre.qtdPopVuneravel}}</td>
                    <td>{{dadosCapitacaoPonderada.calculoQuadrimestre.qtdPopNaoVuneravel}}</td>
                  </tr>
                </tbody>
              </table>
              <p>Fonte: E-GESTOR, {{parcelaDIsf}}</p>
              <p class="c-indent">
                O Gráfico 1 mostra uma comparação entre os cadastros realizados,
                a realizar e o potencial de cadastro, bem como a população em
                condições de vulnerabilidade e os não vulneráveis.
              </p>
            </div>
            <div class="grafico">
              <p>O Gráfico 1 apresenta a situação do cadastro no município</p>
            <div class="grafico-col col-lg-12">
              <div class="box">
                <div class="box-header">
                  <h4 class="box-title">
                    <i class="icofont-chart-bar-graph"></i>
                  </h4>
                </div>
                <div class="box-body">
                  <div class="row">
                    <div class="col-lg-12">
                      <apexchart
                        type="bar"
                        height="350"
                        :options="chartOptions"
                        :series="chartData"
                        ref="chartData"
                      ></apexchart>

                    </div>
                  </div>
                </div>
              </div>
            </div>
              <p>Fonte: Autoria própria, {{parcelaDIsf}}</p>
            </div>
            <p>
              Em relação ao total de cadastros, tem-se <strong>{{porcentagemVuneravel}}%</strong> da população
              municipal enquadradas em critério de vulnerabilidade e <strong>{{porcentagemNaoVuneravel}}%</strong> não
              vulneráveis.
            </p>
          </div>
            <div class="c-secao-item">
               <br>
              <h3>
                2.1 Recursos da capitação ponderada
              </h3>
               <br>
              <p class="c-indent">
                O valor para o cálculo da capitação ponderada está definido na
                Portaria 169 de 31 de janeiro de 2020 em
                <strong>R$ 50,50 por ano por pessoa</strong> cadastrada e
                vinculada a equipes de Saúde da Família ou Atenção Primária.
                “Esse valor pode chegar a R$ 131,30, de acordo com as
                características de vulnerabilidade do indivíduo e do município
                em que vive” (SAPS, 2020).
              </p>
              <p v-if="verificaSeFaltaCadastrarPositivoOuNegativo === true" class="c-indent">
                Porque falta cadastrar <strong>{{faltaCadastrar.toLocaleString()}} pessoas</strong> (esse
                número pode ser maior), então o município pode receber a mais:
              </p>
              <p v-if="verificaSeFaltaCadastrarPositivoOuNegativo === false" class="c-indent">
                Cadastrou a mais  <strong>{{faltaCadastrar.toLocaleString()}} pessoas</strong> (esse
                número pode ser maior),
                <span v-if="verificaSeIsfMaiorOuMenorQue7 === 'menor que 7'">
                e o ISF municipal está em {{moneyBr(this.dadosDesempenhoIsf.notaIsf).replace('R$','').trim()}}, ou seja, menor que 7, então o município pode receber a mais:
                </span>
                <span v-if="verificaSeIsfMaiorOuMenorQue7 === 'maior que 7'">
                e o ISF municipal está em {{moneyBr(this.dadosDesempenhoIsf.notaIsf).replace('R$','').trim()}}, ou seja, maior ou igual que 7, então o município está recebendo 100% da capitação ponderada.
                </span>
              </p>
              <!-- ---------  Verificação quando o cadastro for maior que o potencial de cadastro    ------------- -->
              <p v-if="verificacaoCadastroForMaiorQuePotencialDeCadastro" class="c-indent">
                Como o potencial de cadastro é menor do que a quantidade de cadastros realizadas, então ao implantar mais equipes de saúde,
                o município pode receber à mais:
              </p>
              <div v-if="verificacaoCadastroForMaiorQuePotencialDeCadastro"
              class="c-secao-item-margin-2">
                <p>
                <ul>
                  <li>
                    <span class="bolinha"></span>
                    <strong style="margin-left: 10px;">
                      {{moneyBr(valorCadastroMaiorQuePotencialAno)}}</strong
                    >
                    por ano; ou
                  </li>
                  <li>
                    <span class="bolinha"></span>
                    <strong style="margin-left: 10px;">
                      {{moneyBr(valorCadastroMaiorQuePotencialMes)}}</strong> por mês.

                  </li>
                </ul>
                </p>
              </div>

              <!-- ------------------- -->
              <div v-if="(verificaSeFaltaCadastrarPositivoOuNegativo === true && verificacaoCadastroForMaiorQuePotencialDeCadastro === false) ||
              (verificaSeFaltaCadastrarPositivoOuNegativo === false &&
              verificaSeIsfMaiorOuMenorQue7 === 'menor que 7' && verificacaoCadastroForMaiorQuePotencialDeCadastro === false) "
              class="c-secao-item-margin-2">
                <p>
                <ul>
                  <li>
                    <span class="bolinha"></span>
                    <strong style="margin-left: 10px;">
                      {{moneyBr(valorFaltaCadastrarPorAno)}}</strong
                    >
                    por ano; ou
                  </li>
                  <li>
                    <span class="bolinha"></span>
                    <strong style="margin-left: 10px;">
                      {{moneyBr(valorFaltaCadastrarPorMes)}}</strong> por mês.

                  </li>
                </ul>
                </p>
              </div>
              <p class="c-indent">
                O Quadro 3 mostra o valor recebido pelo município por mês na
                capitação ponderada, complementação financeira e quanto pode
                receber a mais pelos cadastros e qualificação dos cadastros.
              </p>
              <div>
                <p class="mb-0">Quadro 3 – Recursos da capitação ponderada</p>
                <table class="tabela inicial">
                <thead>
                  <tr>
                  <th>Capitação ponderada</th>
                  <th>Complementação Financeira</th>
                  <th>Pode receber a mais</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>

                    <td>{{dadosCapitacaoPonderada.valorCapacitacaoPonderada}}</td>
                    <td>{{dadosCapitacaoPonderada.valorComplementacaoFinanceira}}</td>
                    <td><strong>{{moneyBr(valorAReceberCapitacaoPonderada)}}</strong></td>
                  </tr>
                </tbody>
              </table>
              <p>Fonte: E-GESTOR, {{parcelaDIsf}}</p>
              </div>
              <p class="c-indent">
                A possível perda de recursos observada, tendo em vista as regras
                definidas para o modelo de financiamento do custeio da Atenção
                Primária à Saúde com recursos federais, indicada neste
                componente (Capitação Ponderada), leva em consideração a
                quantidade de munícipes que devem ser cadastrados, vinculados a
                equipes válidas e assistidos pela APS municipal.
              </p>
              <p class="c-indent">
                Nesta análise, os valores projetados de perda no ano de {{extrairAnoParcelaCP}} não
                levaram em consideração as características de ponderação dos
                indivíduos de acordo com o município em que vive. Portanto, esse
                valor é ainda maior.
              </p>
            </div>
            <!--  -->
            <div class="c-secao-item">
               <br>
              <h3>
                2.2 Recomendação técnica
              </h3>
               <br>
              <p class="c-indent">
                A fim de maximizar o recebimento de recursos federais para o
                financiamento de custeio da Atenção Primária à Saúde,
                considerando o componente CAPITAÇÃO PONDERADA no município de
                {{ cidadeCP }} – {{ estadoCP }}, recomenda-se:
              </p>
              <p>
                <ul class="c-secao-item-indent-2">
                  <li v-if="verificaSeFaltaCadastrarPositivoOuNegativo === true">a) Cadastrar as <strong>{{faltaCadastrar.toLocaleString()}}</strong> pessoas ainda não cadastradas, com a correspondente vinculação à equipe de referência para acompanhamento e atendimento assistencial;</li>
                  <li v-if="verificaSeFaltaCadastrarPositivoOuNegativo === false">a) Realizar busca ativa constante para cadastrar as pessoas ainda não cadastradas, com a correspondente vinculação à equipe de referência para acompanhamento e atendimento assistencial;</li>
                  <li>b) Implantar ou manter programa de Educação Permanente e Continuada em Saúde no âmbito da Atenção Primária à Saúde;</li>
                  <li>c) Qualificar permanentemente os cadastros já realizados, validando-os sistematicamente a cada quadrimestre e atualizando-os, pelo menos, uma vez por ano;</li>
                  <li>d) Realizar o monitoramento e a avaliação dos cadastros de munícipes com informações atualizadas em tempo real.</li>
                </ul>
              </p>
            </div>
          </div>
      </div>



            <!-- Inicio seção 3 -->
        <div class="c-secao">
          <div class="new-page">
            <div class="header-blue">3 PAGAMENTO POR DESEMPENHO</div>
            <div class="c-secao-item">
              <p class="c-indent">O pagamento por desempenho é mais um componente do Programa Previne Brasil. Para o ano de 2022 ele está regulamentado pela Portaria 102 de 20 de janeiro de 2022 que faz alteração nos 7 indicadores que foram trabalhados até o final do ano de 2021:</p>
              <p>
                <ul style="margin-left: 24px; margin-top: 10px; margin-bottom: 10px">
                <li>1.	Proporção de gestantes com pelo menos 6 (seis) consultas pré-natal realizadas, sendo a 1ª (primeira) até a 12ª (décima segunda) semana de gestação;</li>
                <li>2.	Proporção de gestantes com realização de exames para sífilis e HIV;</li>
                <li>3.	Proporção de gestantes com atendimento odontológico realizado;</li>
                <li>4.	Proporção de mulheres com coleta de citopatológico na APS;</li>
                <li>5.	Proporção de crianças de 1 (um) ano de idade vacinadas na APS contra Difteria, Tétano, Coqueluche, Hepatite B, infecções causadas por haemophilus influenzae tipo b e Poliomielite inativada;</li>
                <li>6.	Proporção de pessoas com hipertensão, com consulta e pressão arterial aferida no semestre; e</li>
                <li>7.	Proporção de pessoas com diabetes, com consulta e hemoglobina glicada solicitada no semestre.</li>
                </ul>
              </p>



              <p class="c-indent">A Portaria 2.713 de 6 de outubro de 2020,
                estabelece o valor por equipe que é repassado ao município
                de acordo com o Indicador Sintético Final (ISF). O ISF mede o
                desempenho municipal e varia entre 0 e 10 com base nos resultados dos
                7 indicadores que as equipes trabalharam no quadrimestre avaliado.</p></div>
              <p class="c-indent">O Gráfico 2 mostra a evolução do ISF do município de <strong>{{cidadeDIsf}} – {{estadoDIsf}}</strong> ao longo do tempo e que em <strong>{{quadrimestreReferencia}}</strong> está em <strong>{{moneyBr(this.dadosDesempenhoIsf.notaIsf).replace('R$','').trim()}}</strong>.</p>
                  <div class="grafico">
                  <p>Gráfico 2 – Evolução do Indicador Sintético Final.</p>
                    <div class="grafico-col col-lg-12">
                      <div class="box">
                        <div class="box-header">
                            <h4 class="box-title">
                              <i class="icofont-chart-bar-graph"></i>
                            </h4>
                          </div>
                              <div class="box-body">
                                <div class="row">
                                  <div  class="col-lg-12">
                                      <apexchart
                                        type="line"
                                        height="350"
                                        :options="chartOptions2"
                                        :series="chartData2"
                                        ref="chartData2"
                                        ></apexchart>
                                        </div>
                                      </div>
                                    </div>
                              </div>
                            </div>
                            <p>Fonte: Autoria própria, {{parcelaDIsf}}</p>
                      </div>
              <p class="c-indent">O ISF é calculado com base no conjunto de indicadores de desempenho do Programa Previne Brasil. Se o município atingir meta em todos os indicadores, então o ISF é 10, caso contrário, o ISF é proporcional aos resultados obtidos nos indicadores individualmente. O Gráfico 3 mostra a evolução dos indicadores ao longo do tempo.</p>
              </div>
       <div class="new-page">
              <div class="grafico">
                <p>Gráfico 3 – Evolução dos indicadores do Previne Brasil</p>
                  <div class="grafico-col col-lg-12">
                    <div class="box">
                      <div class="box-header">
                        <h4 class="box-title">
                          <i class="icofont-chart-bar-graph"></i>
                        </h4>
                      </div>
                        <div class="box-body">
                          <div class="row">
                            <div class="options">
                              <span class="label"><span class="bolinhaGrafico consulta_pre_natal"><i class="icofont-close-line-circled"></i></span>Consultas pré-natal</span>
                              <span class="label"><span class="bolinhaGrafico exame_hiv_sifilis"><i class="icofont-close-line-circled"></i></span>Exames HIV e Sífilis</span>
                              <span class="label"><span class="bolinhaGrafico consultas_odontologicas"><i class="icofont-close-line-circled"></i></span>Consultas odontológicas</span>
                              <span class="label"><span class="bolinhaGrafico citopatologicas"><i class="icofont-close-line-circled"></i></span>Citopatológico</span>
                              <span class="label"><span class="bolinhaGrafico vacinas"><i class="icofont-close-line-circled"></i></span>Vacinas</span>
                              <span class="label"><span class="bolinhaGrafico hipertensao"><i class="icofont-close-line-circled"></i></span>Hipertensão</span>
                              <span class="label"><span class="bolinhaGrafico diabeticos"><i class="icofont-close-line-circled"></i></span>Diabéticos</span>
                            </div>
                            <div class="col-lg-12">
                                <apexchart
                                  type="line"
                                  height="350"
                                  :options="chartOptions3"
                                  :series="chartData3"
                                  ref="chartData3">
                                </apexchart>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                  <p>Fonte: Autoria própria, {{parcelaDIsf}}</p>
                    <p class="c-indent">Ao assistir à população na APS, as equipes contribuem para melhorar os resultados dos indicadores e consequentemente o desempenho municipal no Previne Brasil.</p>
              </div>
        <div class="c-secao-item">
                <br>
              <h3>
                3.1 Recursos do pagamento por desempenho
              </h3>
                <br>
              <p class="c-indent">
                O valor máximo que o município de <strong>{{cidadeDIsf}} – {{estadoDIsf}}</strong> pode receber no pagamento por desempenho considerando as equipes (eSF e eAP) válidas no
              <strong>quadrimestre {{quadrimestreReferencia}}</strong> é de <strong>{{moneyBr(pagamentoPorDesempenho)}}</strong> para o quadrimestre <strong>{{quadrimestreReferenciaMaisUm}}</strong>.
              O Quadro 3 apresenta o ISF, o valor máximo, o valor recebido e quanto a mais o município poderia estar recebendo no pagamento por desempenho.
              </p>
            <div class="container-tabela">
                <p class="mb-0">Quadro 3 – Recursos do pagamento por desempenho no quadrimestre {{quadrimestreReferenciaMaisUm}}</p>
                <table class="tabela inicial">
                <thead>
                  <tr>
                  <th>ISF</th>
                  <th>Valor máximo</th>
                  <th>Valor recebido</th>
                  <th>Pode receber a mais</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>{{moneyBr(this.dadosDesempenhoIsf.notaIsf).replace('R$','').trim()}}</strong></td>
                    <td><strong>{{moneyBr(pagamentoPorDesempenho)}}</strong></td>
                    <td><strong>{{moneyBr(valorDoPagamentoPorDesempenhoRecebido)}}</strong></td>
                    <td><strong>{{moneyBr(valorQuePodeReceberAMais)}}</strong></td>

                  </tr>
                </tbody>
              </table>
              <p>Fonte: E-GESTOR, {{parcelaDIsf}}</p>
              </div>
              <p class="c-indent">Vale ressaltar que o resultado do quadrimestre avaliado, ou seja, quadrimestre anterior é condição para pagar o quadrimestre atual, isto é, o quadrimestre de trabalho. Assim, o Quadro 4 mostra uma previsão de valores a serem recebidos pelo município no próximo quadrimestre com base nos resultados atuais dos indicadores.</p>
          <div class="container-tabela">
                <p class="mb-0">Quadro 4 – Recursos do pagamento por desempenho no quadrimestre {{quadrimestreReferenciaMaisDois}}</p>
                <table class="tabela inicial">
                <thead>
                  <tr>
                  <th>Valor máximo</th>
                  <th>Valor a ser recebido</th>
                  <th>Pode receber a mais</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>{{moneyBr(pagamentoPorDesempenho)}}</strong></td>
                    <td><strong>{{moneyBr(valorASerRecebido)}}</strong></td>
                    <td><strong>{{moneyBr(segundoValorQuePodeReceberAMais)}}</strong></td>
                  </tr>
                </tbody>
              </table>
              <p>Fonte: Autoria própria, {{parcelaDIsf}}</p>
              </div>
              <p class="c-indent">Os recursos recebidos no quadrimestre atual com relação ao pagamento por desempenho dependem do ISF do quadrimestre anterior, assim é importante conhecer a previsão e situação atual para tomar decisões e não ter perdas de recursos futuramente.</p>
            </div>
            <!-- começo seção de item -->
          <div class="c-secao-item">
            <br>
              <h3>
                3.2 Recomendação Técnica
              </h3>
              <br>
              <p class="c-indent">
              A fim de maximizar o recebimento de recursos federais para o financiamento de custeio da Atenção Primária à Saúde, considerando o componente <strong>PAGAMENTO POR DESEMPENHO</strong> no município de <strong>{{ cidadeCP }} – {{ estadoCP }}</strong>.</p>
              <p>É imperiosa uma ação direcionada e coordenada para eliminar os riscos das perdas significativas apresentadas que, se ocorrerem, comprometerão a qualidade e a quantidade do atendimento assistencial aos munícipes</p>
                <p>
                <ul class="c-secao-item-indent-2" style="list-style: disc;">
                  <li>Atuar, estratégica e operacionalmente, para melhorar os resultados dos indicadores a partir da assistência à população, perseguindo um ISF de nota 10;</li>
                  <li>Implantar programa de Educação Permanente e Continuada em Saúde no âmbito da Atenção Primária em Saúde;</li>
                  <li>Distribuir as responsabilidades e metas a todos os servidores que participam direta e indiretamente do processo de atendimento aos munícipes, sobretudo considerando as metas definidas e vinculadas ao componente <strong>PAGAMENTO POR DESEMPENHO;</strong></li>
                  <li>Realizar o monitoramento e a avaliação para acompanhamento dos resultados mensais obtidos no que se refere aos resultados alcançados pelos servidores e ao atendimento aos munícipes, sobretudo considerando as metas definidas e vinculadas ao componente <strong>PAGAMENTO POR DESEMPENHO.</strong></li>
                </ul>
              </p>
          </div>
        </div>
    </div>
            <!-- fim seção de item -->
            <!-- fim seção 3 -->
            <!-- Inicio seção 4 -->
             <div class="new-page">
        <div class="c-secao">
          <div class="header-blue">4 AÇÕES ESTRATÉGICAS</div>
            <p class="c-indent">Faz parte desse componente os programas: Programa Saúde na Hora; Equipe de Saúde Bucal (eSB); Unidade Odontológica Móvel (UOM); Centro de Especialidades Odontológicas (CEO); Laboratório Regional de Prótese Dentária (LRPD); Equipe de Consultório na Rua (eCR); Unidade Básica de Saúde Fluvial (UBSF); Equipe de Saúde da Família Ribeirinha (eSFR); Microscopista; Equipe de Atenção Básica Prisional (eABP); Custeio para o ente federativo responsável pela gestão das ações de Atenção Integral à Saúde dos Adolescentes em Situação de Privação de Liberdade; Programa Saúde na Escola (PSE); Programa Academia da Saúde; <strong>Programas de apoio à informatização da APS</strong>; Incentivo aos municípios com residência médica e multiprofissional; Estratégia de Agentes Comunitários de Saúde (ACS); e outros que venham a ser instituídos por meio de ato normativo específico.</p>
            <p class="c-indent">Cada programa ou ação estratégica tem suas próprias regras e requisitos que devem ser atendidos para o município receber os recursos federais.</p>
            <p class="c-indent">Neste relatório, consideramos apenas o PROGRAMAS DE APOIO À INFORMATIZAÇÃO DA APS, que faz parte do Conect SUS e tem por objetivo estimular a informatização das Unidades Básica de Saúde e a qualificação de dados na APS de todo o Brasil.</p>
            <!-- começo seção de item -->
            <div class="c-secao-item">
              <br>
              <h3>
                4.1 Programa Informatiza APS
              </h3>
                <br>
              <p class="c-indent">Esse programa faz parte do Conect SUS e tem por objetivo estimular a informatização das Unidades Básica de Saúde e qualificação de dados na APS de todo o Brasil. O valor do incentivo financeiro de custeio mensal do Informatiza APS está definido na Portaria nº 2.983, de 11 de novembro de 2019.</p>
              <p class="c-indent">O município de <strong>{{ cidadeCP }} – {{ estadoCP }}</strong> tem tipologia <strong>{{dadosCapitacaoPonderada.tipologia}}</strong> e conforme o Quadro 1, está com {{somaEquipesPagas}} equipes (eAP ou eSF) validas no quadrimestre atual, logo, o valor máximo por mês que o município pode receber é <strong>{{moneyBr(valorMensalMaximoDisponívelInformatizacao)}}</strong>. O Quadro 4 apresenta o valor máximo, o valor recebido e quanto o município pode receber a mais no informatiza APS.</p>

              <div class="container-tabela">
                <p class="mb-0">Quadro 5 – Recursos do informatiza APS no quadrimestre atual</p>
                <table class="tabela inicial">
                <thead>
                  <tr>
                  <th>Valor máximo</th>
                  <th>Valor recebido</th>
                  <th>Pode receber a mais</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>{{moneyBr(valorMensalMaximoDisponívelInformatizacao)}}</strong></td>
                    <td><strong>{{moneyBr(valorRecebidoInformatizaAps)}}</strong></td>
                    <td><strong>{{moneyBr(valorQuePodeReceberAMaisInformatizaAps)}}</strong></td>


                  </tr>
                </tbody>
              </table>
              <p>Fonte: E-GESTOR, {{parcelaDIsf}}</p>
              </div>
                <p class="c-indent">Para atender aos requisitos do Informatiza APS é importante conhecer suas regras e realizar Monitoramento e Avaliação constante.</p>


            </div>
              <!-- fim seção de item -->
              <div class="c-secao-item">
                  <br>
                <h3>
                4.1.1 Recomendação técnica
              </h3>
                <br>
              <p class="c-indent">A fim de maximizar o recebimento de recursos federais para o financiamento de custeio da Atenção Primária à Saúde, considerando o componente <strong>PROGRAMAS DE APOIO À INFORMATIZAÇÃO DA APS</strong> no município de <strong>{{ cidadeCP }} – {{ estadoCP }}</strong>, recomenda-se:</p>
              <p>
                <ul class="c-secao-item-indent-2" style="list-style: disc;">
                  <li>Atuar, estratégica e operacionalmente, para melhorar os resultados de todos os indicadores que contribuem direta e indiretamente para a maximização e o correspondente recebimento de todos os recursos federais para melhorar continuamente a Atenção Primária no Município;</li>
                  <li>Implantar um programa de Educação Permanente e Continuada em Saúde no âmbito da Atenção Primária à Saúde;</li>
                  <li>Implantar tecnologia de monitoramento e avaliação para acompanhamento dos resultados mensais obtidos no que se refere aos resultados alcançados pelos servidores e ao atendimento aos munícipes, sobretudo considerando as metas definidas e vinculadas aos componentes <strong>CAPITAÇÃO PONDERADA</strong> e <strong>PAGAMENTO POR DESEMPENHO;</strong></li>
                  <li>Promover a informatização das Unidades Básicas de Saúde;</li>
                  <li>Reforçar o conhecimento e a habilidade no e-SUS, sobretudo no Prontuário Eletrônico do Cidadão (PEC). Mas também podem ser utilizados sistemas próprios ou de terceiros, que se integrem à estratégia e-SUS APS.</li>
                </ul>
              </p>

              </div>
          </div>
 </div>
            <div class="new-page">
          <!-- fim seção 4 -->
          <!-- inicio seção 5 -->
          <div class="c-secao">
          <div class="header-blue">5 CONCLUSÃO</div>
              <p class="c-indent">Este relatório evidencia um conjunto de oportunidades para o Município aumentar os repasses federais, tendo em vista as regras definidas pelo Programa Previne Brasil.</p>
              <p class="c-indent">Considerando os parâmetros analisados neste documento,
              o Município poderá receber recursos federais adicionais por mês no ano de 2022, conforme especificado a seguir:</p>


          <div style="margin-left: 40px;">
            <p>
              <ul>
                <li><strong>a)	Capitação Ponderada</strong>: <strong class="verde">{{moneyBr(valorAReceberCapitacaoPonderada)}}</strong> – por cadastrar os munícipes faltantes, segundo as regras definidas pelo Programa;</li>
                <li><strong>b)	Pagamento por Desempenho</strong>: <strong class="verde">{{moneyBr(segundoValorQuePodeReceberAMais)}}</strong> – com o aumento do ISF para 10, tendo em vista os indicadores de desempenho definidos;</li>
                <li><strong>c)	Incentivo para Ações Estratégicas (Programas de Apoio à Informatização da APS)</strong>: <strong class="verde">{{moneyBr(valorQuePodeReceberAMaisInformatizaAps)}}</strong> – com a informatização e o monitoramento das ações nas 254 equipes de saúde;</li>
                <li><strong>d)	Ainda com relação às Ações Estratégicas (Programas de Apoio à Informatização da APS)</strong> – verificar junto à assessoria técnica municipal a possibilidade de implantação dos demais 16 programas previstos no Previne Brasil.;</li>
              </ul>
            </p>
            </div>

            <p>O incremento financeiro representa um aumento de recursos federais para as ações e serviços de saúde na APS do Município da ordem de, aproximadamente, <strong class="verde">{{moneyBr(totalPrevineBrasil)}}</strong>.</p>
          </div>
             </div>
              <div class="new-page" style="page-break-before: always;">
          <!-- fim seção 5 -->
          <div class="c-secao">
          <div class="header-blue">6 REFERÊNCIAS</div>
          <p>BRASIL. Ministério da Saúde. Gabinete do Ministro. Portaria nº 102, de 20 de janeiro de 2022. Altera a Portaria GM/MS nº 3.222, de 10 de dezembro de 2019, que dispõe sobre os indicadores do pagamento por desempenho, no âmbito do Programa Previne Brasil. Diário Oficial da República Federativa do Brasil. Brasília, DF, 21 jan. 2022, ed. 15, Seção: 1, p. 197.</p>
          <p>BRASIL. Ministério da Saúde. Gabinete do Ministro. Portaria 2.713, de 6 de outubro de 2020. Dispõe sobre o método de cálculo e estabelece o valor do incentivo financeiro federal de custeio do pagamento por desempenho, no âmbito do Programa Previne Brasil. Diário Oficial da República Federativa do Brasil. Brasília, DF, 7 out. 2020, ed. 193, Seção: 1- extra, p. 43.</p>
          <p>BRASIL. Ministério da Saúde. Gabinete do Ministro. Portaria nº 169, de 31 de janeiro de 2020. Define o valor per capita para efeito do cálculo do incentivo financeiro da capitação ponderada do Programa Previne Brasil. Diário Oficial da República Federativa do Brasil. Brasília, DF, 31 jan. 2020, Seção: 1- extra, p. 7.</p>
          <p>BRASIL. Ministério da Saúde. Gabinete do Ministro. Portaria nº 3.222, de 10 de dezembro de 2019. Dispõe sobre os indicadores do pagamento por desempenho, no âmbito do Programa Previne Brasil. Diário Oficial da República Federativa do Brasil. Brasília, DF, 11 dez. 2019, Edição 239, Seção: 1, p. 172.</p>
          <p>BRASIL. Ministério da Saúde. Gabinete do Ministro. Portaria nº 2.979, de 12 de novembro de 2019. Institui o Programa Previne Brasil, que estabelece novo modelo de financiamento de custeio da Atenção Primária à Saúde no âmbito do Sistema Único de Saúde, por meio da alteração da Portaria de Consolidação nº 6/GM/MS, de 28 de setembro de 2017. Diário Oficial da República Federativa do Brasil. Brasília, DF, 13 nov. 2019, ed. 220, Seção: 1, p. 97.</p>
          <p>BRASIL. Ministério da Saúde. Gabinete do Ministro. Portaria nº 2.983, de 11 de novembro de 2019. Institui o Programa de Apoio à Informatização e Qualificação dos Dados da Atenção Primária à Saúde - Informatiza APS, por meio da alteração das Portarias de Consolidação nº 5/GM/MS e nº 6/GM/MS, de 28 de setembro de 2017. Diário Oficial da República Federativa do Brasil. Brasília, DF, 13 nov. 2019, ed. 220, Seção: 1, p. 99.</p>
          <p>BRASIL. Ministério do Planejamento, Desenvolvimento e Gestão; IBGE. Classificação e caracterização dos espaços rurais e urbanos do Brasil: uma primeira aproximação. Rio de Janeiro: IBGE; Coordenação de Geografia, 2017. Disponível em: https://biblioteca.ibge.gov.br/visualizacao/livros/liv100643.pdf. Acesso em: 18 mar. 2022.</p>
          <p>E-GESTOR. Financiamento APS. Disponível em: https://egestorab.saude.gov.br/gestaoaps/relFinanciamento.xhtml.  Acesso em: 18 mar. 2022.</p>
          </div>

          <div class="topo">
          <b-button class="button-topo"  type="button" variant="primary" @click="topo()"><i class="icofont-arrow-up"></i>Topo</b-button>
        </div>
          </div>
             </div>

          <!-- ---------------------------------------------------->
          <!-- ---------------------------------------------------->
          <!-- ---------------------------------------------------->
          <!-- ---------------------------------------------------->
          <!-- ---------------------------------------------------->
      </div>
      </div>

</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs'
import VueApexCharts from 'vue-apexcharts'
import { chartOptions, chartOptions2, chartOptions3 } from '@/mixins/graficoRelatorio'
export default {
  name: 'relatorio',
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      styleNode: null,
      disabled: true,
      step: 1,
      capitacaoPonderada: null,
      desempenhoIsf: null,
      informatizacao: null,
      chartOptions: { ...chartOptions },
      chartOptions2: { ...chartOptions2},
      chartOptions3: { ...chartOptions3},
      chartData: [],
      chartData2: [],
      chartData3: [],
    }
  },
  mounted(){
    console.log('refs', this.$refs)
 let style = document.createElement('style')
  style.type = "text/css"
  style.appendChild(document.createTextNode(''))
  this.styleNode = style.childNodes[0] // a reference I store in the data hash
  document.head.appendChild(style)
  this.styleNode.textContent =`@page {
            size: auto;
            margin: 30mm 5mm 5mm 5mm;
            padding: 300px;
            border: 0;
        }`

  },
  computed: {
    /* Soma das equipes homologadas */

    somaDasEquipesHomologadas(){
      const valor = this.dadosCapitacaoPonderada.nEquipesHomologadas.nEsf + this.dadosCapitacaoPonderada.nEquipesHomologadas.nEap
      return valor
    },
     somaDasEquipesPagas(){
      const valor = this.dadosCapitacaoPonderada.nEquipesPagas.nEsf + this.dadosCapitacaoPonderada.nEquipesPagas.nEap20 + this.dadosCapitacaoPonderada.nEquipesPagas.nEap30
      return valor
    },
    /* --- */
    cadastroMenosPotencialDeCadastro(){
    const valor = this.dadosCapitacaoPonderada.calculoQuadrimestre.cadastroEsfEap - this.dadosCapitacaoPonderada.calculoQuadrimestre.cadastroPotencial
    return valor
    },
    verificacaoCadastroForMaiorQuePotencialDeCadastro(){
      if(this.dadosCapitacaoPonderada.calculoQuadrimestre.cadastroEsfEap > this.dadosCapitacaoPonderada.calculoQuadrimestre.cadastroPotencial) {
        return true
      } else {
        return false
      }
    },
    valorPodeReceberAMaisCaptacaoPonderada(){
      let valor = null
      if(this.valorCadastroMaiorQuePotencialMes > this.valorFaltaCadastrarPorMes) {
        valor  = this.valorCadastroMaiorQuePotencialMes
      } else {
        valor =  this.valorFaltaCadastrarPorMes
      }
    return valor
    },
    totalPrevineBrasil(){
      console.log('')
      const valor = this.valorAReceberCapitacaoPonderada + this.segundoValorQuePodeReceberAMais + this.valorQuePodeReceberAMaisInformatizaAps
      return valor
    },
    podeReceberAMaisCapitacaoPonderada(){
       if(this.verificaSeFaltaCadastrarPositivoOuNegativo === true ||
        this.verificaSeFaltaCadastrarPositivoOuNegativo === false &&
        this.verificaSeIsfMaiorOuMenorQue7 === 'menor que 7'){
        return   this.valorFaltaCadastrarPorMes
        }
        else if(this.verificaSeFaltaCadastrarPositivoOuNegativo === false &&
        this.verificaSeIsfMaiorOuMenorQue7 === 'maior que 7') {
        return  0.00
        } else {
          return 0.00
        }
    },

     podeReceberAMaisInformatizaAps(){
     if(this.verificaSeFaltaCadastrarPositivoOuNegativo === true ||
        this.verificaSeFaltaCadastrarPositivoOuNegativo === false &&
        this.verificaSeIsfMaiorOuMenorQue7 === 'menor que 7'){
        return   this.valorFaltaCadastrarPorMes
        }
        else if(this.verificaSeFaltaCadastrarPositivoOuNegativo === false &&
        this.verificaSeIsfMaiorOuMenorQue7 === 'maior que 7') {
        return  0.00
        } else {
          return 0.00
        }
    },
    // DADOS CAPACITAÇÃO PONDERADA
    dadosCapitacaoPonderada() {
      if (this.$store.state.relatorio.capitacaoPonderada !== null) {
        return this.$store.state.relatorio.capitacaoPonderada
      } else {
        return ''
      }
    },
    cidadeCP() {
      return this.dadosCapitacaoPonderada.municipio
    },
    estadoCP() {
      return this.dadosCapitacaoPonderada.uf
    },
    parcelaCP() {
      const ano = this.dadosCapitacaoPonderada.parcela
      return ano
    },
    faltaCadastrar(){
      console.log(this.metodoParaTransformarEmInteiro(this.dadosCapitacaoPonderada.populacao))
      console.log(this.metodoParaTransformarEmInteiro(this.dadosCapitacaoPonderada.calculoQuadrimestre.cadastroEsfEap))

      let valor = this.metodoParaTransformarEmInteiro(this.dadosCapitacaoPonderada.populacao) - this.metodoParaTransformarEmInteiro(this.dadosCapitacaoPonderada.calculoQuadrimestre.cadastroEsfEap)
      if (Math.sign(valor) === 1) {
        return valor
      } else {
      return valor * (-1)
      }

    },
    verificaSeFaltaCadastrarPositivoOuNegativo(){
      let valor = this.metodoParaTransformarEmInteiro(this.dadosCapitacaoPonderada.populacao) - this.metodoParaTransformarEmInteiro(this.dadosCapitacaoPonderada.calculoQuadrimestre.cadastroEsfEap)
      if (Math.sign(valor) === 1) {
      return true
      } else{
        return false
      }
    },
    /* --------------------- */

    valorAReceberCapitacaoPonderada(){
      let valor = null
      if(this.verificacaoCadastroForMaiorQuePotencialDeCadastro) {
       valor  = this.valorCadastroMaiorQuePotencialMes
      } else if(this.verificaSeFaltaCadastrarPositivoOuNegativo === true ||
              this.verificaSeFaltaCadastrarPositivoOuNegativo === false &&
              this.verificaSeIsfMaiorOuMenorQue7 === 'menor que 7'){
                valor  =  this.valorFaltaCadastrarPorMes
              }
              else if(this.verificaSeFaltaCadastrarPositivoOuNegativo === false &&
              this.verificaSeIsfMaiorOuMenorQue7 === 'maior que 7'){
              valor = 0
              }
              return valor
    },

    /* --------------------- */
    verificaSeIsfMaiorOuMenorQue7(){
      // Se for Maior que 7 retorna true
    if (
          this.metodoParaTransformarEmInteiro(
            this.dadosDesempenhoIsf.notaIsf
          ) >= 7
        ) {
          return 'maior que 7'
        } else
        return 'menor que 7'
    },
    porcentagemVuneravel(){
    const vuneravel =  this.dadosCapitacaoPonderada.calculoQuadrimestre.qtdPopVuneravel
    const cadastrados =this.dadosCapitacaoPonderada.calculoQuadrimestre.cadastroEsfEap
    const valor = vuneravel / cadastrados * 100
    return valor.toFixed(2).replace('.',',')
    },
    porcentagemNaoVuneravel(){
    const naoVuneravel =  this.dadosCapitacaoPonderada.calculoQuadrimestre.qtdPopNaoVuneravel
    const cadastrados = this.dadosCapitacaoPonderada.calculoQuadrimestre.cadastroEsfEap
    const valor =  naoVuneravel / cadastrados * 100
    return  valor.toFixed(2).replace('.',',')
    },
    /* Situação quando cadastro for maior que o potencial de cadastro  */
    valorCadastroMaiorQuePotencialAno(){
     const valor  =  this.cadastroMenosPotencialDeCadastro * 50.50
     return valor
    },
    valorCadastroMaiorQuePotencialMes(){
     const valor  =  (this.cadastroMenosPotencialDeCadastro * 50.50) / 12
     return valor
    },
    /* Situação normal  */
    valorFaltaCadastrarPorAno(){
     const falta =  this.faltaCadastrar
     const valor  = falta * 50.50
     return valor
    },
    valorFaltaCadastrarPorMes(){
     const falta =  this.faltaCadastrar
     const valor  = (falta * 50.50) / 12
     return valor
    },

    /* -------------------- */
    extrairAnoParcelaCP() {
      const ano = this.dadosCapitacaoPonderada.parcela.split('/')[1]
      return ano
    },
    calculoPotencialQuadrimestreCP() {
      const valor = this.dadosCapitacaoPonderada.calculoQuadrimestre.cadastroPotencial.toLocaleString()
      return valor
    },
    quadrimestreQtdPagamentoCadastroCP() {
      const valor = this.dadosCapitacaoPonderada.calculoQuadrimestre.qtdCadastroPagamento.toLocaleString()
      return valor
    },




    // ----------------------------------------------
    // DADOS DESEMPENHO ISF
    dadosDesempenhoIsf() {
      if (this.$store.state.relatorio.desempenhoIsf !== null) {
        return this.$store.state.relatorio.desempenhoIsf
      } else {
        return ''
      }
    },
    
    cidadeDIsf() {
      return this.dadosDesempenhoIsf.municipio
    },
    estadoDIsf() {
      return this.dadosDesempenhoIsf.uf
    },
    parcelaDIsf() {
      const ano = this.dadosDesempenhoIsf.parcela
      return ano
    },
    somaEquipesPagas(){
      return this.dadosCapitacaoPonderada.calculoQuadrimestre.qtdEsfQuadrimestre + this.dadosCapitacaoPonderada.calculoQuadrimestre.qtdEap20Quadrimestre + this.dadosCapitacaoPonderada.calculoQuadrimestre.qtdEap30Quadrimestre
    },
    extrairAnoParcelaDIsf() {
      const ano = this.dadosDesempenhoIsf.parcela.split('/')[1]
      return ano
    },
    quadrimestreReferencia() {
      const referencia = this.dadosDesempenhoIsf.quadrimestreReferencia.split(
        'Q'
      )
      const valor = `${referencia[0]} Q${referencia[1]}`
      return valor
    },
    quadrimestreReferenciaMaisUm(){
 const referencia = this.dadosDesempenhoIsf.quadrimestreReferencia.split(
        'Q'
      )
      let resultadoMaisUm = parseInt(referencia[1])
      const valor = `${referencia[0]} Q${resultadoMaisUm + 1}`
      return valor
    },
    quadrimestreReferenciaMaisDois(){
 const referencia = this.dadosDesempenhoIsf.quadrimestreReferencia.split(
        'Q'
      )
      let resultadoMaisUm = parseInt(referencia[1])
      const valor = `${referencia[0]} Q${resultadoMaisUm + 2}`
      return valor
    },
    pagamentoPorDesempenho() {
      const quantitativoValidas = this.dadosDesempenhoIsf
        .quantitativoEquipesHomologadasValidasScnesQuadrimestreAvaliado
        const quantitativoNovas = this.dadosDesempenhoIsf
        .quantitativoEquipesNovasHomologadasValidasScnesCompetencia
      const eSf = quantitativoValidas.eSf + quantitativoNovas.eSf
      const valorParaEsf = 3225
      const multiplicaEsf = eSf * valorParaEsf
      /* -------------------- */
      const eAp20 = quantitativoValidas.eAp20 + quantitativoNovas.eAp20
      const valorParaEap20 = 1612.5
      const multiplicaEap20 = eAp20 * valorParaEap20
      /* -------------------- */
      const eAp30 = quantitativoValidas.eAp30 + quantitativoNovas.eAp30
      const valorParaEap30 = 2418.75
      const multiplicaEap30 = eAp30 * valorParaEap30
      const valor = multiplicaEsf + multiplicaEap20 + multiplicaEap30
      return valor
    },
    valorDoPagamentoPorDesempenhoRecebido(){
    const valorTabela = this.metodoStringParaFormatoAmericano(this.dadosDesempenhoIsf.valorTotal)
    console.log('valor tabela', valorTabela)
    return valorTabela
    },
    valorASerRecebido(){
    const iSfNotaMultiplicadoPor10 = this.dadosDesempenhoIsf.notaIsf * 10
    const valor  = (iSfNotaMultiplicadoPor10 / 100) * this.pagamentoPorDesempenho

    return valor
    },
    valorQuePodeReceberAMais(){
      const valor = this.pagamentoPorDesempenho - this.valorDoPagamentoPorDesempenhoRecebido
       console.log('valorQuePodeReceberAMais', valor)
     return valor
    },
    segundoValorQuePodeReceberAMais(){
    const valor = this.pagamentoPorDesempenho - this.valorASerRecebido
     return valor
    },
    equipesHomologadas() {
      const equipes = this.dadosDesempenhoIsf
        .quantitativoEquipesHomologadasValidasScnesQuadrimestreAvaliado
      const valor = equipes.eSf + equipes.eAp20 + equipes.eAp30
      return valor
    },

    perdaMensalDeRecursosNoQuadrimestre() {
      const pagamentoPorDesempenho = this.pagamentoPorDesempenho
      const valorMensalEfetivamenteRecebido = this.metodoStringParaFormatoAmericano(
        this.dadosDesempenhoIsf.valorTotal
      )
      const valor = pagamentoPorDesempenho - valorMensalEfetivamenteRecebido
      return valor
    },
    PerdaTotalDeRecursosNoQuadrimestre() {
      const valor = this.perdaMensalDeRecursosNoQuadrimestre * 4
      return valor
    },

    //  ----------------------------------------------
    // DADOS INFORMATIZAÇÃO
    dadosInformatizacao() {
      if (this.$store.state.relatorio.informatizacao !== null) {
        return this.$store.state.relatorio.informatizacao
      } else {
        return ''
      }
    },
    cidadeInformatizacao() {
      return this.dadosInformatizacao.municipio
    },
    estadoInformatizacao() {
      return this.dadosInformatizacao.uf
    },
    parcelaInformatizacao() {
      const ano = this.dadosInformatizacao.parcela
      return ano
    },
    extrairAnoParcelaInformatizacao() {
      const ano = this.dadosInformatizacao.parcela.split('/')[1]
      return ano
    },
    equipesHomologadasInformatizacao() {
      const equipes = this.dadosInformatizacao.qtdDeEquipesHomologadas
      return equipes
    },
    valorMensalEfetivamenteRecebidoInformatizacao() {
      const value = this.dadosInformatizacao.valor
      return value
    },
    valorMensalMaximoDisponívelInformatizacao() {
      const tipologia = this.dadosCapitacaoPonderada.tipologia.toLowerCase()
      const quantitativoValidas = this.dadosDesempenhoIsf
        .quantitativoEquipesHomologadasValidasScnesQuadrimestreAvaliado
        const quantitativoNovas = this.dadosDesempenhoIsf
        .quantitativoEquipesNovasHomologadasValidasScnesCompetencia
      const qtdEsf = quantitativoValidas.eSf  + quantitativoNovas.eSf
      const qtdEap20 = quantitativoValidas.eAp20 + quantitativoNovas.eAp20
      const qtdEap30 = quantitativoValidas.eAp30 + quantitativoNovas.eAp30

      let valor = null
      if (
        tipologia === 'urbano' ||
        tipologia === 'intermediário adjacente'
      ) {
        const esf = 1700.0 * qtdEsf
        const eap20 = 850.0 * qtdEap20
        const eap30 = 1275.0 * qtdEap30
        valor = esf + eap20 + eap30
      }
      if (
        tipologia === 'intermediário remoto' ||
        tipologia === 'rural adjacente'
      ) {
        const esf = 2000.0 * qtdEsf
        const eap20 = 1000.0 * qtdEap20
        const eap30 = 1500.0 * qtdEap30
        valor = esf + eap20 + eap30
      }
      if (tipologia === 'rural remoto') {
        const esf = 2300.0 * qtdEsf
        const eap20 = 1150.0 * qtdEap20
        const eap30 = 1725.0 * qtdEap30
        valor = esf + eap20 + eap30
      }

      return valor
    },
    valorRecebidoInformatizaAps(){
      const valor = this.dadosInformatizacao.valor
      return valor
    },
    valorQuePodeReceberAMaisInformatizaAps(){
      const valorMaximo = this.valorMensalMaximoDisponívelInformatizacao
      const valorRecebido = this.metodoStringParaFormatoAmericano(this.valorRecebidoInformatizaAps)
      const valor  = valorMaximo - valorRecebido
      return valor
    },
    perdaMensalInformatiza() {
      const valorMensalMaximoDisponivelInformatizacao = this
        .valorMensalMaximoDisponívelInformatizacao
      const valerMensalRecebido = this.metodoStringParaFormatoAmericano(
        this.valorMensalEfetivamenteRecebidoInformatizacao
      )
      const valor =
        valorMensalMaximoDisponivelInformatizacao - valerMensalRecebido
      return valor
    },
    perdaTotalDeRecursosDoAno() {
      const valor = this.perdaMensalInformatiza * 12
      return valor
    },
    // ----------------------------------------------
    dataHoje() {
      const timeElapsed = Date.now()
      const today = new Date(timeElapsed)
      return today.toLocaleDateString()
    }
  },
  methods: {

  async grafico1(){
  this.chartData  = await [
          {
            data: [
            this.metodoParaTransformarEmInteiro(this.dadosCapitacaoPonderada.calculoQuadrimestre.qtdPopNaoVuneravel),
            this.metodoParaTransformarEmInteiro(this.dadosCapitacaoPonderada.calculoQuadrimestre.qtdPopVuneravel),
            this.metodoParaTransformarEmInteiro(this.faltaCadastrar),
            this.metodoParaTransformarEmInteiro(this.dadosCapitacaoPonderada.calculoQuadrimestre.cadastroEsfEap),
            this.metodoParaTransformarEmInteiro(this.dadosCapitacaoPonderada.calculoQuadrimestre.cadastroPotencial),
            this.metodoParaTransformarEmInteiro(this.dadosCapitacaoPonderada.populacao)
              ]
          }
        ]
        let array_xaxis = null
        console.log('verificaSeFaltaCadastrarPositivoOuNegativo', this.verificaSeFaltaCadastrarPositivoOuNegativo)
        if(this.verificaSeFaltaCadastrarPositivoOuNegativo === true){
      array_xaxis = [
      'Não Vuneraveis',
      'Vuneraveis',
      'Falta cadastrar',
      'Cadastros realizados',
      'Cadastro potencial',
      'População IBGE'
    ]
        }
        if(this.verificaSeFaltaCadastrarPositivoOuNegativo === false){

      array_xaxis = [
      'Não Vuneraveis',
      'Vuneraveis',
      'Cadastros a mais',
      'Cadastros realizados',
      'Cadastro potencial',
      'População IBGE'
    ]
        }
        console.log('array_xaxis', array_xaxis)
        await  this.$refs.chartData.updateOptions({
            xaxis: {
              categories: array_xaxis
            },

          })
   },
 async grafico2() {


      try {
        let response = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/resultado/municipio/' +
            this.dadosCapitacaoPonderada.ibge
        )
        if (response) {
          let response2 = response.data
          let array_xaxis = []
          let array_chart_isf = []

          //preencher a legenda
          for (const item of response2) {
            array_xaxis.push(item.quadrimestre)
          }

          for (let i = 0; i < array_xaxis.length; i++) {
            var eixo_x_atual = array_xaxis[i]
            for (const item of response2) {
              var resultado_isf = 0
              if (item.quadrimestre == eixo_x_atual) {
                resultado_isf = item.isf
                break
              } else {
                resultado_isf = null
              }
            }
            array_chart_isf.push(resultado_isf)
          }
          this.$refs.chartData2.updateOptions({
            xaxis: {
              categories: array_xaxis
            },
           /*  title: {
              text: `${this.dadosCapitacaoPonderada.municipio} - ${this.dadosCapitacaoPonderada.uf}`
            }, */
           /*  subtitle: {
              text: `Indicador Sintético Final`
            }, */
            yaxis: {
              min: 0,
              max: 10
            }
          })
          this.$refs.chartData2.updateSeries([
            {
              name: 'ISF',
              data: array_chart_isf
            }
          ])
        }
      } catch (error) {
        console.log(error)
      }
    },
  async grafico3() {


      try {
        let response = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/resultado/municipio/' +
            this.dadosCapitacaoPonderada.ibge
        )
        if (response) {
          let response2 = response.data
          let array_xaxis = []
          let array_chart_pre_natal = [],
            array_chart_hiv_sifilis = [],
            array_chart_consultas_odontologicas = [],
            array_chart_citologico = [],
            array_chart_imunizacao = [],
            array_chart_hipertensao = [],
            array_chart_hemoglobina = []

          //preencher a legenda
          for (const item of response2) {
            array_xaxis.push(item.quadrimestre)
          }

          for (let i = 0; i < array_xaxis.length; i++) {
            var eixo_x_atual = array_xaxis[i]
            for (const item of response2) {
              var resultado_pre_natal = 0
              var resultado_hiv_sifilis = 0
              var resultado_consultas_odontologicas = 0
              var resultado_citologico = 0
              var resultado_imunizacao = 0
              var resultado_hipertensao = 0
              var resultado_hemoglobina = 0
              if (item.quadrimestre == eixo_x_atual) {
                resultado_pre_natal = item.pn_6_consultas
                resultado_hiv_sifilis = item.pn_hiv_sifilis
                resultado_consultas_odontologicas = item.pn_odontologia
                resultado_citologico = item.citopatologico
                resultado_imunizacao = item.crianca_polio_penta
                resultado_hipertensao = item.pa_hipertensao
                resultado_hemoglobina = item.hg_diabetes
                break
              } else {
                resultado_pre_natal = null
                resultado_hiv_sifilis = null
                resultado_consultas_odontologicas = null
                resultado_citologico = null
                resultado_imunizacao = null
                resultado_hipertensao = null
                resultado_hemoglobina = null
              }
            }
            array_chart_pre_natal.push(resultado_pre_natal)
            array_chart_hiv_sifilis.push(resultado_hiv_sifilis)
            array_chart_consultas_odontologicas.push(
              resultado_consultas_odontologicas
            )
            array_chart_citologico.push(resultado_citologico)
            array_chart_imunizacao.push(resultado_imunizacao)
            array_chart_hipertensao.push(resultado_hipertensao)
            array_chart_hemoglobina.push(resultado_hemoglobina)
          }

          this.$refs.chartData3.updateOptions({
            xaxis: {
              categories: array_xaxis
            },
           /*  title: {
              text: `${this.dadosCapitacaoPonderada.municipio} - ${this.dadosCapitacaoPonderada.uf}`
            },
            subtitle: {
              text: `Indicadores do Previne Brasil.`
            }, */
            yaxis: {
              min: 0,
              max: 100
            }
          })
          this.$refs.chartData3.updateSeries([
            {
              name: 'Consultas pré-natal',
              data: array_chart_pre_natal
            },
            {
              name: 'Exames HIV e Sífilis',
              data: array_chart_hiv_sifilis
            },
            {
              name: 'Consultas odontológicas',
              data: array_chart_consultas_odontologicas
            },
            {
              name: 'Citopatológico',
              data: array_chart_citologico
            },
            {
              name: 'Vacinas',
              data: array_chart_imunizacao
            },
            {
              name: 'Hipertensão',
              data: array_chart_hipertensao
            },
            {
              name: 'Diabéticos',
              data: array_chart_hemoglobina
            }
          ])
        }
      } catch (error) {
        console.log(error)
      }
    },



      async  go() {
      if (this.step === 1) {
        this.step = 2
      await this.grafico1()
      await this.grafico2()
      await this.grafico3()
      } else {
        this.step = 1
        this.disabled = true
      }
    },
    imprimir(){
      window.print()
    },
    topo(){
      window.scrollTo(0, 0);
    },








    VerificaValorNegativoOuPositivo(valor) {
      if (Math.sign(valor) === 1) {
        return true
      } else {
        return false
      }
    },

    moneyBr(value, options = { style: 'currency', currency: 'BRL' }) {
      return value.toLocaleString('pt-br', options)
    },
    metodoParaTransformarEmInteiro(valor) {

      if (typeof valor === 'string') {
        let a = valor.replaceAll('.', '')
        let b = parseInt(a)

        return b
      } else {

        return valor
      }
    },
    metodoStringParaFormatoAmericano(valor) {
      // eslint-disable-next-line no-useless-escape

      const arrumando = valor
        .replace('R$', '')
        .replaceAll('.', '')
        .replace(',', '.')
      const formatoAmericano = parseFloat(arrumando)
      return formatoAmericano
    },
    VerificaSeNumeroInteiroE0(valor) {
      if (valor < 1) {
        return 'nenhuma'
      } else {
        return valor
      }
    },
    verifica(valor) {
      if (isNaN(valor) === false) {
        const transformaParaNumero = parseFloat(valor)
        console.log('transformaParaNumero', transformaParaNumero)
        return transformaParaNumero
      }
    },

    async onFileChange(e) {
      const file = await e.target.files[0]
      const data = await file.arrayBuffer()

      const workbook = await XLSX.read(data)
      console.log('workbook', workbook)
      this.capitacaoPonderada = await XLSX.utils.sheet_to_json(
        workbook.Sheets[workbook.SheetNames[0]],
        {
          header: 1
        }
      )
      this.desempenhoIsf = await XLSX.utils.sheet_to_json(
        workbook.Sheets[workbook.SheetNames[2]],
        {
          header: 1
        }
      )
      this.informatizacao =  await XLSX.utils.sheet_to_json(
        workbook.Sheets[workbook.SheetNames[12]],
        {
          header: 1
        }
      )
        await this.enviarCommit()

    },
    separandoDadosCapitacaoPonderada(capitacaoPonderada) {
      const payload = {
        uf: capitacaoPonderada[1],
        municipio: capitacaoPonderada[2],
        ibge: capitacaoPonderada[3],
        compCnes: capitacaoPonderada[4],
        parcela: capitacaoPonderada[5],
        tipologia: capitacaoPonderada[6],
        populacao: capitacaoPonderada[7],
        nEquipesCredenciadas: {
          nEsf: capitacaoPonderada[8],
          nEap: capitacaoPonderada[9]
        },
        nEquipesHomologadas: {
          nEsf: capitacaoPonderada[10],
          nEap: capitacaoPonderada[11]
        },
        nEquipesPagas: {
          nEsf: capitacaoPonderada[12],
          nEap20: capitacaoPonderada[13],
          nEap30: capitacaoPonderada[14]
        },
        calculoQuadrimestre: {
          cadastroEsfEap: capitacaoPonderada[15],
          cadastroPotencial: capitacaoPonderada[16],
          qtdEsfQuadrimestre: capitacaoPonderada[17],
          qtdEap20Quadrimestre: capitacaoPonderada[18],
          qtdEap30Quadrimestre: capitacaoPonderada[19],
          qtdPopVuneravel: capitacaoPonderada[20],
          qtdPopNaoVuneravel: capitacaoPonderada[21],
          qtdCadastroPagamento: capitacaoPonderada[22],
          valorPontoVuneravel: capitacaoPonderada[23],
          valorPontoNaoVuneravel: capitacaoPonderada[24],
          valorPontoPorEquipe: capitacaoPonderada[25],
          valorPagamentoPorEquipeQuadrimestre: capitacaoPonderada[26]
        },
        composicaoEquipesPagamentoCompetencia: {
          qtdEsfCompletas: capitacaoPonderada[27],
          qtdEsfIncompletas75: capitacaoPonderada[28],
          qtdEsfIncompletas50: capitacaoPonderada[29],
          qtaEsfIncompletas25: capitacaoPonderada[30],
          qtdEap20Completas: capitacaoPonderada[31],
          qtaEap20Incompletas: capitacaoPonderada[32],
          qtaEap30Completas: capitacaoPonderada[33],
          qtaEap30Incompletas: capitacaoPonderada[34],
          valorTotalPagamento: capitacaoPonderada[35]
        },
        equipesNovas: {
          qtdEsfCompletas: capitacaoPonderada[36],
          qtdEsf75Incompletas: capitacaoPonderada[37],
          qtdEsf50Incompletas: capitacaoPonderada[38],
          qtdEsf25Incompletas: capitacaoPonderada[39],
          qtdEap20Completas: capitacaoPonderada[40],
          qtdEap20Incompletas: capitacaoPonderada[41],
          qtdEap30Completas: capitacaoPonderada[42],
          qtdEap30Incompletas: capitacaoPonderada[43],
          cadastroPotencial: capitacaoPonderada[44],
          valorPagamentoEquipe: capitacaoPonderada[45],
          valorTotalPagamento: capitacaoPonderada[46]
        },
        equipesEspecificas: {
          qtdEcr: capitacaoPonderada[47],
          cadastroEcr: capitacaoPonderada[48],
          valorPontoEcr: capitacaoPonderada[49],
          valorPagamentoEcr: capitacaoPonderada[50],
          qtdEap: capitacaoPonderada[51],
          cadastroEap: capitacaoPonderada[52],
          valorPontoEap: capitacaoPonderada[53],
          valorPagamentoEap: capitacaoPonderada[54],
          qtdEsfr: capitacaoPonderada[55],
          cadastroVuneravelEsfr: capitacaoPonderada[56],
          cadastroNaoVuneravelEsfr: capitacaoPonderada[57],
          valorPontoVuneravelEsfrb: capitacaoPonderada[58],
          valorPontoNaoVuneravelEsfr: capitacaoPonderada[59],
          valorPagamentoVuneravelEsfr: capitacaoPonderada[60],
          valorPagamentoNaoVuneravelEsfr: capitacaoPonderada[61]
        },
        valorCapacitacaoPonderada: capitacaoPonderada[62],
        valorComplementacaoFinanceira: capitacaoPonderada[63],
        ajuste: {
          adicional: capitacaoPonderada[64],
          desconto: capitacaoPonderada[65]
        },
        valorTotal: capitacaoPonderada[66]
      }
      console.log('capitacaoPonderada', payload)
      return payload
    },
    separandoDadosDesempenhoIsf(desempenhoIsf) {
      const payload = {
        uf: desempenhoIsf[0],
        municipio: desempenhoIsf[1],
        ibge: desempenhoIsf[2],
        parcela: desempenhoIsf[3],
        quadrimestreReferencia: desempenhoIsf[4],
        notaIsf: desempenhoIsf[5],
        quantitativoEquipesHomologadasValidasScnesQuadrimestreAvaliado: {
          eSf: desempenhoIsf[6],
          eAp30: desempenhoIsf[7],
          eAp20: desempenhoIsf[8]
        },
        valorPagamentoDesempenhoIsf: desempenhoIsf[9],
        ValorReferente100PorCentoDosIndicadores: desempenhoIsf[10],
        quantitativoEquipesNovasHomologadasValidasScnesCompetencia: {
          eSf: desempenhoIsf[11],
          eAp30: desempenhoIsf[12],
          eAp20: desempenhoIsf[13]
        },
        valorPorDesempenhoEquipesNovas: desempenhoIsf[14],
        ajuste: {
          adicional: desempenhoIsf[15],
          desconto: desempenhoIsf[16]
        },
        valorTotal: desempenhoIsf[17]
      }
      console.log('desempenhoIsf', payload)
      return payload
    },
    separandoDadosInformatizacao(informatizacao) {
      const payload = {
        uf: informatizacao[1],
        municipio: informatizacao[2],
        ibge: informatizacao[3],
        parcela: informatizacao[4],
        qtdDeEquipesHomologadas: informatizacao[5],
        qtdDeEquipesPagas: informatizacao[6],
        valor: informatizacao[7],
        ajuste: {
          adicional: informatizacao[8],
          desconto: informatizacao[9]
        }
      }
      console.log('informatizacao', payload)
      return payload
    },
  async  enviarCommit() {
      const payload = {
        capitacaoPonderada: this.separandoDadosCapitacaoPonderada(
          this.capitacaoPonderada[5]
        ),
        desempenhoIsf: this.separandoDadosDesempenhoIsf(this.desempenhoIsf[5]),
        informatizacao: this.separandoDadosInformatizacao(
          this.informatizacao[4]
        )
      }


      this.$store.commit('setRelatorio', payload)
      this.disabled = false
    },

  }
}
</script>

<style scoped>

p {
  text-align: justify;
}
li {
  text-align: justify;
}
#relatorio {
}
#relatorio .titulo-page {
  margin: 45px 0px;
  display: flex;
  justify-content: center;
}
#relatorio .titulo-page h1 {
  font-weight: bold;
}
#relatorio .subtitulo-page {
  margin: 0 auto;
  max-width: 600px;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-bottom: 45px;
}
#relatorio .subtitulo-page h2 {
  font-weight: bold;
}
#relatorio .lista-container {
  margin: 0 auto;
  max-width: 800px;
}
#relatorio .lista-container .c-lista .c-item {
  display: flex;
  justify-content: space-between;
}
.c-item-coluna {
  display: flex;
  flex-direction: column;
}
#relatorio .lista-container .nome {
}
#relatorio .lista-container .nome .valor {
}
.valor {
  font-weight: bold;
}
.header-blue {
  text-transform: uppercase;
  font-weight: bold;
  background: #8eaadb;
  margin: 15px 0px;
}
.header-grey {
  text-transform: uppercase;
  font-weight: bold;
  background: #bfbfbf;
  margin: 15px 0px;
}
.header-pink {
  text-transform: uppercase;
  font-weight: bold;
  background: #f7caac;
  margin: 15px 0px;
}
.c-secao {
  margin: 15px 0px;
}
.c-secao-item {
  margin: 15px 0px;
}
.c-secao-item-indent {
  margin-left: 20px;
}
h3 {
  font-size: 19px;
  font-weight: bold;
}
.verde {
  color: #00b050;
  font-weight: bold;
}
.c-resumo {
  font-weight: bold;
}
.c-resumo .resumo-valor {
  font-weight: normal;
}
@media screen and (max-width: 850px) {
  #relatorio {
    margin: 0px 20px;
  }
}
@media screen and (max-width: 650px) {
  #relatorio .subtitulo-page h2 {
    font-size: 20px;
  }
}
.subtitulo-2 {
  text-align: center;
  margin: 0 auto;
  max-width: 720px;
  margin-bottom: 45px;
}
.c-indent {
  text-indent: 40px;
  text-align: justify;
}
.c-secao-item-margin-2 {
  margin-left: 20px;
}
.c-secao-item-indent-2{
  margin-left: 40px;
}
.bolinha {
  width: 5px;
  height: 5px;
  border: 3px solid red;
  border-radius: 97%;
  display: inline-block;
  background: red;
  margin-bottom: 3px;
}
.bolinha-preta{
  width: 5px;
  height: 5px;
  border: 3px solid rgb(0, 0, 0);
  border-radius: 97%;
  display: inline-block;
  background: rgb(0, 0, 0);
  margin-bottom: 3px;
}
    #relatorio  .options {
        display: none;
 /*    visibility: hidden; */
    max-width: 83%;
    margin: 0px auto;
    font-size: 12px;
    text-align: center;
    font-size: 12px
}
.options .label {
      margin: 2px 5px;
}
.bolinhaGrafico i{

  font-size: 15px;
  margin-right: 3px;
}
.bolinhaGrafico {
    display: inline-block;
/*     height: 12px;
    width: 12px;
    left: 0px;
    top: 0px;
    border-width: 0px;
    border-color: rgb(255, 255, 255);
    border-radius: 12px;
    margin-right: 3px; */
}
.consulta_pre_natal{
background: #008ffb !important;
color: #008ffb;
}
.exame_hiv_sifilis{
background: #ff9933 !important;
color: #ff9933;
}
.consultas_odontologicas{
background: #ff0000 !important;
color: #ff0000;
}
.citopatologicas{
background: #009933 !important;
color: #009933;
}

.vacinas {
background: #ffff00 !important;
color: #ffff00;
}
.hipertensao {
background: #000000 !important;
color: #000000;
}
.diabeticos{
background: #ff33cc !important;
color: #ff33cc;
}
.tabela {
  width: 100%;
  table-layout: fixed;
}
 .tabela, th, td {

    border: 1px solid #00000059;
    color: black;
}
 .tabela thead {
    color: black;
    text-align: center;
    background: #d9d9d9
}
 .tabela tbody {
   text-align: center;
 }
 .tabela thead, th {

    border-bottom: 0px;
}
.tabela, .sem-negrito-th thead tr th{
  font-weight: unset;

}
.tabela, .inicial thead  {
text-align: initial;
}
.tabela, .inicial tbody  {
text-align: initial;
}
.tabela, .inicial thead tr th  {
    font-weight: unset;
padding-left: 10px;
}
.tabela, .inicial tbody tr td  {
padding-left: 10px;
}
.quadro-1 thead tr th {

line-height: 40px;

}
.quadro-1 tbody tr td {

line-height: 30px;

}
.botoes{
    max-width: 920px;
    display: flex;
    justify-content: space-between;
    margin: 30px auto;
}
.voltar{
   border-radius: 32px;
    display: inline-block;
    background-color: #0fafd7;
    color: #fff;
    font-size: 15px;
    padding: 0px 30px;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: inset 0 -2px 0 rgb(0 0 0 / 25%);
}
.imprimir{
    border-radius: 32px;
    display: inline-block;
    background-color: #0fafd7;
    color: #fff;
    font-size: 15px;
    padding: 0px 30px;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: inset 0 -2px 0 rgb(0 0 0 / 25%);
}
.topo{
  display: flex;
    justify-content: flex-end;
    max-width: 920px;
    margin: 16px auto;
}
.button-topo{
    border-radius: 32px;
    display: inline-block;
    background-color: #0fafd7;
    color: #fff;
    font-size: 15px;
    padding: 0px 30px;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: inset 0 -2px 0 rgb(0 0 0 / 25%);
}
.botoes-upload{

    display: flex;
    max-width: 920px;
    margin: 60px auto;
    align-items: center;
    justify-content: center;

}
@media print{
#relatorio .botoes{
  visibility: hidden;
}
#relatorio .topo {
    visibility: hidden;
}
#relatorio .options {
   display: block;
}

/*  @page {
            size: auto;
            margin: 5mm 5mm 5mm 5mm;
            padding: 300px;
            border: 0;
        } */
        .new-page {
            position: relative;
            page-break-inside: avoid;
           /*  height: 355mm; */
            /*  height: 160mm; */
        }
}
</style>
<style>
@media print{
#relatorio .apexcharts-legend{
  display: none!important;

}
}
</style>
